import React, {
  startTransition,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { fetcher as fetcherAPI } from '../../helpers/fetcher'
import { ACTIONS } from '../../store/Actions'
import { DataContext } from '../../store/GlobalState'
import shape from './icons/Shape.svg'
import { Container, DriversContent, DriversImg, DriversTitle } from './styles'

const Actors = ({ gid, scenario }) => {
  const {
    state: { langForTransState, isTranslated },
    dispatch,
  } = useContext(DataContext)
  const actorsDOMRef = useRef()
  const actorsDOMRef2 = useRef()

  const [isDriversOpened, setisDriversOpened] = React.useState(true)
  const [translations, settranslations] = useState(null)

  const [originalTitle, setoriginalTitle] = useState(
    () => actorsDOMRef.current?.innerHTML,
  )
  const openingDriversHandler = () => {
    setisDriversOpened(() => !isDriversOpened)
  }

  useEffect(() => {
    const fetcher = async () => {
      const res1 = await fetcherAPI.translation(
        'en',
        langForTransState,
        originalTitle,
      )
      settranslations(() => {
        return {
          res1,
        }
      })
    }
    !!isTranslated && !!originalTitle && fetcher()
  }, [isTranslated, originalTitle, langForTransState])

  useEffect(() => {
    if (!!scenario?.actors?.length) {
      if (true) {
        if (!!actorsDOMRef.current?.innerHTML && !actorsDOMRef2.current) {
          actorsDOMRef2.current = actorsDOMRef.current?.innerHTML
        }
        !!actorsDOMRef2.current &&
          !originalTitle &&
          setoriginalTitle(() => actorsDOMRef2.current)

        // dispatch({
        //   type: ACTIONS.GETWHOLEHTMLCARD2,
        //   payload:  true
        // })
      }
    }
  }, [isTranslated, scenario?.actors, dispatch, originalTitle])
  useEffect(() => {
    startTransition(() => {
      setTimeout(() => {
        dispatch({
          type: ACTIONS.ACTORSDOM,
          payload: actorsDOMRef.current?.outerHTML,
        })
      }, 1000)
    })
  }, [actorsDOMRef.current?.outerHTML, dispatch, translations, isTranslated])

  return (
    !!scenario?.actors?.length && (
      <>
        {!isTranslated ? (
          <Container ref={actorsDOMRef}>
            <DriversTitle>Actors used in this scenario:</DriversTitle>
            <ul
              style={{
                paddingLeft: '12px',
                marginTop: '0.5rem',
                marginBottom: '0.5rem',
              }}>
              {!!isDriversOpened &&
                !!scenario?.actors?.length &&
                scenario?.actors?.map((actor, index) => {
                  return <DriversContent key={index}>{actor}</DriversContent>
                })}
            </ul>

            <DriversImg
              src={shape}
              onClick={openingDriversHandler}
              style={{
                transform: `rotate(${!!isDriversOpened ? '0' : '180deg'})`,
              }}
            />
          </Container>
        ) : (
          <Container
            ref={actorsDOMRef}
            dangerouslySetInnerHTML={{
              __html: translations?.res1?.data,
            }}
            style={{
              marginTop: '30px',
              marginBottom: '30px',
            }}></Container>
        )}
      </>
    )
  )
}

export default Actors
